<div class="modal-header">
  <h4 class="modal-title" id="UserInfoLabel">{{resources.UserInformation}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="user-info-row">
    <span class="user-info-label">{{resources.Username}}</span>
    <span class="user-info-value">{{ profile.idTokenClaims.userid }}</span>
  </div>
  <div class="user-info-row">
    <span class="user-info-label">{{resources.Name}}</span>
    <span class="user-info-value">{{ profile.idTokenClaims.given_name }} {{ profile.idTokenClaims.family_name }}</span>
  </div>
  <div class="user-info-row">
    <span class="user-info-label">{{resources.Email}}</span>
    <span class="user-info-value">{{ profile.idTokenClaims.email }}</span>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-sm btn-secondary" (click)="close()">{{resources.Close}}</button>
  <button type="button" class="btn btn-sm btn-danger" (click)="logout()">{{resources.Logout}}</button>
</div>
